import type { ExpenseListQuery } from '@chukua/common';
import { Select } from 'antd';
import { DriverSearchSelect } from '../../drivers/public/DriverSearchSelect';
import { TruckSearchSelect } from '../../fleet/features/trucks/public/TruckSearchSelect';
import type { ListQueryControls } from '../../../shared/hooks/use-list-query';
import { AGE_FILTER_OPTIONS } from '../policies/expense-age';

/** Driver, truck and how long it has waited. Category is the table's column filter; every choice lands in the URL through `setQuery`. */
export function ApprovalFilters({ list }: { list: Pick<ListQueryControls<ExpenseListQuery>, 'query' | 'setQuery'> }) {
  const { query, setQuery } = list;
  return (
    <div className="flex flex-wrap gap-3">
      <div className="w-full sm:w-56">
        <DriverSearchSelect allowClear value={query.driverId?.[0]} onChange={(driverId) => setQuery({ driverId: driverId ? [driverId] : undefined })} />
      </div>
      <div className="w-full sm:w-56">
        <TruckSearchSelect allowClear value={query.truckId?.[0]} onChange={(truckId) => setQuery({ truckId: truckId ? [truckId] : undefined })} />
      </div>
      <Select
        allowClear
        className="w-full sm:w-48"
        placeholder="Any time waiting"
        aria-label="Time waiting"
        value={query.minAgeHours}
        options={[...AGE_FILTER_OPTIONS]}
        onChange={(minAgeHours: number | undefined) => setQuery({ minAgeHours })}
      />
    </div>
  );
}
